import React, { useState } from 'react';
import airtistImg from './assets/artist.jpg';

const App = () => {
  const [cartCount, setCartCount] = useState(0);

  const services = [
    {
      id: 1,
      name: 'Custom Portrait Painting',
      price: 15000,
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      reviews: 45,
      badge: 'Popular'
    },
    {
      id: 2,
      name: 'Digital Illustrations',
      price: 8000,
      image: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      reviews: 32,
      badge: 'Digital'
    },
    {
      id: 3,
      name: 'Logo & Brand Design',
      price: 12000,
      image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      reviews: 28,
      badge: 'Business'
    },
    {
      id: 4,
      name: 'Mural & Wall Art',
      price: 50000,
      image: 'https://images.unsplash.com/photo-1596548438137-d51ea5c83ca4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 5.0,
      reviews: 15,
      badge: 'Large Scale'
    },
    {
      id: 5,
      name: 'Pencil Sketches',
      price: 5000,
      image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      reviews: 38,
      badge: 'Classic'
    },
    {
      id: 6,
      name: 'Watercolor Paintings',
      price: 10000,
      image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      reviews: 22,
      badge: 'Artistic'
    }
  ];

  const addToCart = () => {
    setCartCount(cartCount + 1);
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white font-poppins">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-lg shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-montserrat font-black text-primary-500 tracking-tight">Exlilkodak</h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Home</button>
                <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Services</button>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Gallery</button>
                <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Contact</button>
                <button onClick={() => scrollToSection('contact')} className="btn-primary">Get Quote</button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="min-h-screen bg-gradient-to-br from-primary-500 via-orange-500 to-yellow-400 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-transparent to-white/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
            <div className="text-white">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6">
                🎨 Professional Artwork Services in Futo, Owerri
              </div>
              <h1 className="text-5xl lg:text-7xl font-montserrat font-black leading-tight mb-6 tracking-tight">
                Professional Artwork & Creative Design Services
              </h1>
              <p className="text-xl lg:text-2xl mb-8 opacity-95 leading-relaxed max-w-2xl">
                From custom portraits to digital illustrations - we bring your creative vision to life with professional artwork services. Trusted by clients across Owerri and beyond.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={() => scrollToSection('services')} className="bg-white text-primary-500 px-8 py-4 rounded-full text-lg font-bold hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 text-center">
                  View Services <i className="fas fa-arrow-right ml-2"></i>
                </button>
                <button onClick={() => scrollToSection('gallery')} className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white hover:text-primary-500 transition-all duration-300 text-center">
                  View Gallery
                </button>
              </div>
            </div>
            <div className="relative">
              <img src={airtistImg} alt="Professional Artwork" className="rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500" />
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl">
                <div className="flex items-center space-x-3">
                  <i className="fas fa-shipping-fast text-primary-500 text-2xl"></i>
                  <div>
                    <p className="font-semibold text-gray-800">Free Consultation</p>
                    <p className="text-sm text-gray-600">For all projects</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Banner */}
      <section className="bg-gradient-to-r from-primary-500 to-orange-500 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white mb-12">
            <h2 className="text-3xl font-montserrat font-bold mb-4">Why Clients Choose Exlilkodak</h2>
            <p className="text-xl opacity-90">Owerri's premier artwork service provider</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center text-white">
              <i className="fas fa-palette text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Custom Artwork</h3>
              <p className="opacity-90">Personalized designs</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-award text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Quality Guaranteed</h3>
              <p className="opacity-90">Professional standards</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-clock text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Fast Turnaround</h3>
              <p className="opacity-90">Quick delivery</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-handshake text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Affordable Rates</h3>
              <p className="opacity-90">Competitive pricing</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="services" className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-gray-900 mb-4">Our Services</h2>
            <p className="text-xl text-gray-600">Professional artwork solutions for every need</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div key={service.id} className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 overflow-hidden group">
                <div className="relative">
                  <img src={service.image} alt={service.name} className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-sm font-semibold text-white ${
                    service.badge === 'Popular' ? 'bg-primary-500' :
                    service.badge === 'Digital' ? 'bg-green-600' :
                    service.badge === 'Business' ? 'bg-blue-600' :
                    service.badge === 'Large Scale' ? 'bg-red-600' :
                    service.badge === 'Classic' ? 'bg-orange-600' :
                    service.badge === 'Artistic' ? 'bg-teal-600' : 'bg-gray-600'
                  }`}>
                    {service.badge}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="text-yellow-400">
                      {'★'.repeat(Math.floor(service.rating))}{'☆'.repeat(5 - Math.floor(service.rating))}
                    </div>
                    <span className="text-gray-600 ml-2">({service.reviews} reviews)</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h3>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                      <span className="text-2xl font-bold text-primary-500">₦{service.price.toLocaleString()}</span>
                      <span className="text-gray-500 text-sm">Starting from</span>
                    </div>
                  </div>
                  <button onClick={() => scrollToSection('contact')} className="w-full btn-primary">
                    Get Quote
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-gray-900 mb-4">Our Artwork Portfolio</h2>
            <p className="text-xl text-gray-600">Showcasing our professional artwork and client projects</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="lg:col-span-2 lg:row-span-2">
              <img src="https://images.unsplash.com/photo-1578321272176-b7bbc0679853?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Artist at work" className="w-full h-full object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1541961017774-22349e4a1262?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Art supplies" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Oil painting" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Canvas painting" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Paint brushes" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gradient-to-r from-primary-500 to-orange-500 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-montserrat font-bold mb-6">Exlilkodak - Professional Artwork Services</h2>
              <p className="text-xl mb-8 opacity-95 leading-relaxed">
                Based in Futo, Owerri, we specialize in creating stunning artwork that brings your vision to life. From portraits to digital designs, we deliver professional quality art services.
              </p>
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <h3 className="text-4xl font-bold mb-2">100+</h3>
                  <p className="opacity-90">Happy Clients</p>
                </div>
                <div className="text-center">
                  <h3 className="text-4xl font-bold mb-2">50+</h3>
                  <p className="opacity-90">Completed Projects</p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img src="https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Art Studio" className="w-full h-40 object-cover rounded-2xl shadow-lg" />
                <img src="https://images.unsplash.com/photo-1578321272176-b7bbc0679853?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Artist working" className="w-full h-32 object-cover rounded-2xl shadow-lg" />
              </div>
              <div className="pt-8">
                <img src="https://images.unsplash.com/photo-1541961017774-22349e4a1262?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Art supplies collection" className="w-full h-48 object-cover rounded-2xl shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 via-transparent to-orange-500/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-white mb-4">Get In Touch</h2>
            <p className="text-xl text-gray-300">Ready to bring your artistic vision to life? Contact us today</p>
          </div>
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-map-marker-alt text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Visit Our Studio</h3>
              <p className="text-gray-300 leading-relaxed">
                Exlilkodak Art Studio<br />
                Futo, Owerri<br />
                Imo State, Nigeria
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-phone text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Call Us</h3>
              <p className="text-gray-300 leading-relaxed">
                08104975045<br />
                Mon-Sat: 9AM-6PM
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-envelope text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Email Us</h3>
              <p className="text-gray-300 leading-relaxed">
                info@exlilkodak.com<br />
                exlilkodak@gmail.com
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-400">&copy; 2024 Exlilkodak. All rights reserved.</p>
            </div>
            <div className="flex space-x-6">
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;